import "../field-container/field-container";
import "../menu/menu-item";
import "../picker/picker";

import { html, LitElement, TemplateResult } from "lit";

import { PickerChangeEvent } from "../picker/picker";
import { getConfiguration, Theme } from "../../utils/configuration";
import { customElement } from "lit/decorators.js";

const THEMES = getConfiguration().themes;

@customElement("oz-themes-switcher")
export class ThemesSwitcher extends LitElement {
	private readonly _currentTheme: string = document.documentElement.getAttribute("data-theme-name") ?? "default";

	protected override render(): TemplateResult {
		return html`
			<oz-field-container>
				<oz-picker @oz:change="${this.handleThemeChanged}" fluid size="s" placeholder="Theme"> ${THEMES.map((theme, _) => html` <oz-menu-item value="${theme.name}" ?selected="${theme.name === this._currentTheme}"> ${theme.name === this._currentTheme ? html`<b>${this.renderName(theme)}</b>` : html`<span>${this.renderName(theme)}</span>`} </oz-menu-item> `)} </oz-picker>
			</oz-field-container>
		`;
	}

	private renderName(theme: Theme): TemplateResult {
		return html`${theme.name} <small>(${theme.variant})</small>`;
	}

	private async handleThemeChanged(e: PickerChangeEvent<string>): Promise<void> {
		const newTheme = e.detail.value;
		if (this._currentTheme === newTheme) {
			return;
		}

		const backlink = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
		window.location.href = `/public-internals/set-theme?name=${newTheme}&backlink=${backlink}`;
	}
}
